import type { AhPayload, AhTier } from '../ahReport';
import { fmtNum, fmtTimeNL, elapsedDayCount } from '../utils';

function KPI({
  label,
  value,
  sub,
  cadence,
  split,
}: {
  label: string;
  value: string;
  sub?: string;
  cadence?: 'live' | 'daily';
  split?: { label: string; value: string }[];
}) {
  return (
    <div className="kpi">
      <div className="kpi-label">
        {label}
        {cadence && <span className={'cadence-badge ' + cadence}>{cadence === 'live' ? 'real-time' : 'dagelijks'}</span>}
      </div>
      <div className="kpi-value">{value}</div>
      <div className="kpi-sub">{sub && <span>{sub}</span>}</div>
      {split && split.length > 0 && (
        <div className="kpi-split">
          {split.map((s) => (
            <div key={s.label} className="kpi-split-item">
              <span className="kpi-split-k">{s.label}</span>
              <span className="kpi-split-v">{s.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function KPIGrid({ data }: { data: AhPayload }) {
  const t = data.totals;
  const tierGames = (tier: AhTier) => data.venues.filter((v) => v.tier === tier).reduce((s, v) => s + (v.gamesPlayed ?? 0), 0);
  const goldGames = tierGames('gold');
  const silverGames = tierGames('silver');
  const elapsed = elapsedDayCount(data.days);
  return (
    <>
      <div className="kpi-grid">
        <KPI label="Unieke bezoekers" value={fmtNum(t.uniqueVisitors)} sub={`gem. ${fmtNum(Math.round(t.uniqueVisitors / elapsed))} / dag`} cadence="live" />
        <KPI label="Unieke spelers" value={fmtNum(t.uniquePlayers ?? 0)} sub="totaal over de hele campagne" cadence="live" />
        <KPI label="Totaal aantal bezoeken" value={fmtNum(t.uniqueVisits)} sub="sessies van unieke bezoekers" cadence="live" />
        <KPI label="Time in campaign" value={fmtTimeNL(t.presentationTime)} sub={`gem. ${fmtTimeNL(t.avgPresentationPerUser)} / gebruiker`} cadence="daily" />
      </div>
      <div className="kpi-grid kpi-grid-3 kpi-grid-row2">
        <KPI
          label="Spellen gespeeld"
          value={fmtNum(t.gameplays)}
          sub={`gem. ${t.avgGamesPerUser} per speler`}
          cadence="live"
          split={[
            { label: 'Goud', value: fmtNum(goldGames) },
            { label: 'Zilver', value: fmtNum(silverGames) },
          ]}
        />
        <KPI label="Oefenspellen gestart" value={fmtNum(t.practiceGames)} sub="practice games over alle venues" cadence="live" />
        <KPI label="Digital missions voltooid" value={fmtNum(t.missions)} sub="over alle venues" cadence="daily" />
      </div>
    </>
  );
}
